import React from 'react';
import { BanIcon, ScaleIcon, FlameIcon } from 'lucide-react';
import { Card } from '../ui/Card';
export function WhyFailed() {
  return <section className="py-16 md:py-24 bg-stone-50" data-id="element-210">
      <div className="container mx-auto px-4" data-id="element-211">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-213">
            Por qué lo que intentaste falló
          </h2>
          <p className="text-lg text-stone-600" data-id="element-214">
            El problema no eres tú, es el enfoque incorrecto.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-215">
          <Card className="text-center hover:shadow-md transition-shadow" data-id="element-216">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-red-600 mb-6" data-id="element-217">
              <BanIcon className="h-8 w-8" data-id="element-218" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-219">
              Dietas Genéricas
            </h3>
            <p className="text-stone-600" data-id="element-220">
              Restricción sin orden que solo genera ansiedad y el temido efecto
              rebote.
            </p>
          </Card>

          <Card className="text-center hover:shadow-md transition-shadow" data-id="element-221">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 text-orange-600 mb-6" data-id="element-222">
              <ScaleIcon className="h-8 w-8" data-id="element-223" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-224">
              Detox Extremos
            </h3>
            <p className="text-stone-600" data-id="element-225">
              Pasar hambre solo funciona por 2 días. Luego abandonas por pura
              supervivencia.
            </p>
          </Card>

          <Card className="text-center hover:shadow-md transition-shadow" data-id="element-226">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-227">
              <FlameIcon className="h-8 w-8" data-id="element-228" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-229">
              Inflamación vs Grasa
            </h3>
            <p className="text-stone-600" data-id="element-230">
              No distinguen entre estar inflamada y tener exceso de grasa. Se
              atacan diferente.
            </p>
          </Card>
        </div>
      </div>
    </section>;
}